import { SelectLoadingState } from '@revolut-internal/ui-kit'

export const getInputLoadingState = (
  isLoading: boolean,
  isError: boolean,
): SelectLoadingState => {
  if (isError) return 'failed'
  if (isLoading) return 'pending'
  return 'ready'
}
